import i18next from "../../i18n";
import { BIDDING_TYPES, BIDDING_TYPES_LABELS } from "../../utils";

/** Reducer action names for the "general data" step (see generalBidReducer). */
export const actions = {
  UPDATE_INTERNAL_CODE: "UPDATE_INTERNAL_CODE",
  UPDATE_PAYMENT_METHOD: "UPDATE_PAYMENT_METHOD",
  UPDATE_PAYMENT_TERM: "UPDATE_PAYMENT_TERM",
  UPDATE_START_DATE: "UPDATE_START_DATE",
  UPDATE_FINISH_DATE: "UPDATE_FINISH_DATE",
  UPDATE_START_TIME: "UPDATE_START_TIME",
  UPDATE_FINISH_TIME: "UPDATE_FINISH_TIME",
  UPDATE_CONSULTATION_START: "UPDATE_CONSULTATION_START",
  UPDATE_CONSULTATION_END: "UPDATE_CONSULTATION_END",
  UPDATE_EXPIRE_DATE: "UPDATE_EXPIRE_DATE",
  UPDATE_BUYER_PICKS_UP: "UPDATE_BUYER_PICKS_UP",
  UPDATE_COMMENT: "UPDATE_COMMENT",
  UPDATE_NAME: "UPDATE_NAME",
  UPDATE_INCOTERM: "UPDATE_INCOTERM",
  UPDATE_CURRENCY: "UPDATE_CURRENCY",
  // Sets the whole `files` array in one dispatch — used by the launch-from-PR
  // prefill (OrderByRequest). The RFQ builder only ever ADD/REMOVEs, so it never
  // dispatches this, but the shared reducer handles it for both flows.
  UPDATE_FILES: "UPDATE_FILES",
  ADD_FILE: "ADD_FILE",
  REMOVE_FILE: "REMOVE_FILE",
};

export type File = {
  fileName: string;
  type: string;
  fileURL: string;
};

/** Bidding-type radio options (step 1). */
export const types = [
  {
    id: 1,
    title: BIDDING_TYPES_LABELS.NORMAL,
    value: BIDDING_TYPES.NORMAL,
    description: i18next.t("tenders.normal"),
  },
  {
    id: 2,
    title: BIDDING_TYPES_LABELS.INVERSE,
    value: BIDDING_TYPES.INVERSE,
    description: i18next.t("tenders.inverse.title"),
  },
];

/**
 * Simple/multiple vs. joint options. Never rendered as a manual selector any
 * more: `computeComplexType` auto-routes by item count (utils/biddingType.ts).
 */
export const complexTypes = [
  {
    id: 1,
    title: BIDDING_TYPES_LABELS.SIMPLE_OR_MULTIPLE,
    value: BIDDING_TYPES.NORMAL,
    description: i18next.t("tenders.simpleOrMultiple"),
  },
  {
    id: 2,
    title: BIDDING_TYPES_LABELS.JOINT,
    value: BIDDING_TYPES.JOINT,
    description: i18next.t("tenders.joint"),
  },
];

export const initialState = {
  paymentMethod: "",
  paymentTerm: "",
  internalCode: "",
  startDateValue: "",
  startTimeValue: "",
  finishDate: "",
  endTimeValue: "",
  consultationStartValue: "",
  consultationEndValue: "",
  expireDate: false,
  buyerPicksUp: false,
  comment: "",
  incoTerm: "DAP",
  currency: "",
  files: [] as File[],
};

/** The 5 labels shown in the Carbon ProgressIndicator (steps 1-5; the
 * summary is step 6 and re-uses the last, "Summary", label). */
export const WIZARD_STEPS: { id: number; labelKey: string }[] = [
  { id: 1, labelKey: "tenders.biddingType" },
  { id: 2, labelKey: "tenders.selectMaterials" },
  { id: 3, labelKey: "tenders.selectSuppliers" },
  { id: 4, labelKey: "tenders.generalData" },
  { id: 5, labelKey: "tenders.summary" },
];
